<mat-expansion-panel #panel class="accordion">
    <mat-expansion-panel-header>
        <div class="accordion-header">
            <h6 class="bold dark-grey accordion-name-barcode-container">
                <div class="accordion-name">
                    {{ pack?.name }} ({{ pack?.materials?.length + pack?.services?.length }})
                    <i class="pack-pill">
                        <mat-icon svgIcon="pack-pill" class="basket-item-icon"></mat-icon>
                    </i>
                </div>
                <div class="text-muted">
                    {{ pack?.barcode }}
                </div>
            </h6>
            <div class="pack-delete cursor">
                <div mat-icon-button (click)="removePackFromBasket()" color="warn">
                    <mat-icon class="pack-delete-icon" svgIcon="delete-outline">
                    </mat-icon>
                </div>
            </div>
        </div>
    </mat-expansion-panel-header>
    <div class="pack-divider"></div>
    <div *ngFor="let material of pack?.materials" class="material-container" [ngClass]="itemClassName(material)">
        <div class="material-details">
            <h6 class="dark-grey">
                {{material.name}}
                <mat-icon svgIcon="materials" class="basket-item-icon">
                </mat-icon>
            </h6>
            <h6 class="dark-grey">
                <div class="material-barcode text-muted">
                    <div class="barcode">
                        SKU {{material.barcode}}
                    </div>
                    <div class="material-quantities-and-unit-of-measure text-muted">
                        {{ material.availableStock || 0}} | {{ material.unitOfMeasure | uppercase}}
                    </div>
                </div>
            </h6>
        </div>
        <div class="material-quantities">
            <div class="material-increment cursor">
                <button mat-icon-button class="mat-icon-button" *ngIf="canIncreaseMaterialQuantity"
                    (click)="$event.stopPropagation(); incrementMaterialQuantity(material)">
                    <mat-icon class="material-increment-icon" svgIcon="create">
                    </mat-icon>
                </button>
            </div>
            <div class="material-input-field cursor">
                <input type="number" class="form-control" min="0" disabled="true" [name]="material.barcode"
                    [(ngModel)]="material.packQuantity" [name]="material.barcode"
                    (change)="updateMaterialQuantity(material, $event.target.value)">
            </div>
            <div class="material-decrement cursor">
                <button mat-icon-button class="mat-icon-button" *ngIf="canDecreaseMaterialQuantity"
                    (click)="$event.stopPropagation(); decrementMaterialQuantity(material)">
                    <mat-icon class="material-decrement-icon" svgIcon="remove">
                    </mat-icon>
                </button>
            </div>
            <div class="material-delete cursor">
                <button mat-icon-button class="mat-icon-button" *ngIf="canDeletMaterial"
                    (click)=" $event.stopPropagation(); removeFromPack(material)">
                    <mat-icon class="material-delete-icon" svgIcon="delete-outline">
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div *ngFor="let service of pack?.services" class="material-container">
        <div class="material-details">
            <h6 class="dark-grey">
                {{service.name}}
                <mat-icon svgIcon="services-letter" class="basket-item-icon">
                </mat-icon>
            </h6>
            <h6 class="dark-grey">
                <div class="material-barcode text-muted">
                    <div class="barcode">
                        SERVICE {{service.barcode}}
                    </div>
                </div>
            </h6>
        </div>
        <div class="material-quantities">
            <div class="material-delete cursor">
                <button mat-icon-button class="mat-icon-button" *ngIf="canDeletMaterial"
                    (click)=" $event.stopPropagation(); removeServicesFromPack(service)">
                    <mat-icon class="material-delete-icon" svgIcon="delete-outline">
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
</mat-expansion-panel>